










































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IWallet } from "@/interfaces";
import WalletVoters from "@/components/wallet/Voters.vue";
import WalletVote from "@/components/wallet/Vote.vue";
import { IPFSService } from "@/services";
const blacklist = require("@/components/wallet/blacklist.json");

@Component({
  components: {
    WalletVoters,
    WalletVote,
  },
})
export default class WalletDelegate extends Vue {
  @Prop({ required: true }) public wallet: IWallet;

  private logoData: string | null = null;

  get isBlacklisted() {
    if (this.wallet && this.wallet.address && blacklist.wallets.includes(this.wallet.address)) {
      return true;
    }
  }

  get delegate() {
    return this.$store.getters["delegates/byPublicKey"](this.wallet.publicKey);
  }

  public mounted() {
    this.fetchLogo();
  }

  private async fetchLogo() {
    // @ts-ignore
    this.logoData = await IPFSService.fetchData(this.wallet.files.logo);
  }

  get delegateStatus() {
    const activeThreshold = this.$store.getters["network/activeDelegates"];
    if (this.wallet.isResigned) {
      return { text: this.$t("WALLET.DELEGATE.STATUS.RESIGNED"), class: "text-status-not-forging" };
    }
    if (this.delegate.rank && this.delegate.rank <= activeThreshold) {
      return { text: this.$t("WALLET.DELEGATE.STATUS.ACTIVE"), class: "text-status-forging" };
    }
    return { text: this.$t("WALLET.DELEGATE.STATUS.STANDBY"), class: "text-status-missed-round" };
  }
}
